// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__9orLt","panel":"Robot_panel__6+VWY","wrapper":"Robot_wrapper__gVBZA","info":"Robot_info__+ey4B","unit":"Robot_unit__cccDb"};